import React, { useMemo } from "react";
import InputFloatLabel from "components/Design/Input/InputFloatLabel";
import { useTranslation } from "gatsby-plugin-react-i18next";

function RoomGuestInput({
  viewRateBlock,
  rooms,
  adults,
  children,
  infants,
  onClick,
  error,
  suffixIcon,
}) {
  const { t } = useTranslation("homepage");
  const guestDetails = useMemo(() => {
    let details = "";
    if (rooms) details += t("Room", { count: rooms });
    if (rooms && (adults || children)) details += ", ";

    if (adults) details += t("Adult", { count: adults });
    if (adults && children) details += ", ";

    if (children) details += t("Child", { count: children });

    if (infants) details += `, ${t("Infant", { count: infants })}`;

    return details;
  }, [children, rooms, adults, infants, t]);

  return (
    <div className="h-[58px]">
      <InputFloatLabel
        name={t("room_and_guest")}
        error={error}
        value={guestDetails}
        label={t("Room & Guest")}
        onClick={onClick}
        className="h-full cursor-pointer rounded-sm"
        noBorder
        readOnly
        floatLabelByDefault
        suffixIcon={suffixIcon}
        viewRateBlock={viewRateBlock}
      />
    </div>
  );
}

export default RoomGuestInput;
